import HometownGroupsFormContainer from './HometownGroupsFormContainer';

export default HometownGroupsFormContainer;
